import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useState } from "react";
import "./AffiliateCenter.css";

export default function FirstLogin({ onshowMember }) {
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const handleCheckbox1Change = (event) => {
    setIsChecked1(event.target.checked);
  };

  const handleCheckbox2Change = (event) => {
    setIsChecked2(event.target.checked);
  };
  return (
    <>
      <div className="ac_registration_layout">
        <h3 className="ac_registration_title">Become an Affiliate Member</h3>
        
        <div className="ac_form_container">
          <Row>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>First Name</Form.Label>
              <Form.Control className="ac_input" placeholder="First Name" />
            </Col>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>Last Name</Form.Label>
              <Form.Control className="ac_input" placeholder="Last Name" />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>Email Address</Form.Label>
              <Form.Control className="ac_input" type="email" placeholder="email@example.com" />
            </Col>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control className="ac_input" placeholder="+1 (555) 000-0000" />
            </Col>
          </Row>
          <Row>
            <Col className="ac_form_group mb-4">
              <Form.Label>Legal Address</Form.Label>
              <Form.Control className="ac_input" placeholder="Your full legal address" />
              <small className="ac_helper_text">
                Note: Please provide your address as it appears on your legal documents for identity verification during withdrawals.
              </small>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="ac_form_group mb-4">
              <Form.Label>City</Form.Label>
              <Form.Control className="ac_input" placeholder="City" />
            </Col>
            <Col md={4} className="ac_form_group mb-4">
              <Form.Label>State / Province</Form.Label>
              <Form.Control className="ac_input" placeholder="State" />
            </Col>
            <Col md={4} className="ac_form_group mb-4">
              <Form.Label>Country</Form.Label>
              <Form.Control className="ac_input" placeholder="Country" />
            </Col>
          </Row>
        </div>

        <div className="ac_consent_section">
          <label className="ac_checkbox_wrapper mb-3">
            <input
              type="checkbox"
              checked={isChecked1}
              onChange={handleCheckbox1Change}
              className="ac_checkbox_input"
            />
            <span className="checkbox_text">
              I understand that identity verification (KYC) is required before my first withdrawal request can be processed.
            </span>
          </label>
          
          <label className="ac_checkbox_wrapper mb-4">
            <input
              type="checkbox"
              checked={isChecked2}
              onChange={handleCheckbox2Change}
              className="ac_checkbox_input"
            />
            <span className="checkbox_text">
              I certify that all information provided above is accurate and belongs to me.
            </span>
          </label>
        </div>

        <div className="ac_registration_footer">
          <p className="ac_disclaimer">
            <strong>Disclaimer:</strong> By joining the ZEX PR Wire Affiliate Program, you agree to our terms of service. We process your data in accordance with our Privacy Policy.
          </p>
          
          <button
            className={`ac_next_btn ${(!isChecked1 || !isChecked2) ? 'disabled' : ''}`}
            disabled={!isChecked1 || !isChecked2}
            onClick={onshowMember}
          >
            Create My Affiliate Account
          </button>
        </div>
      </div>
    </>
  );
}
